import { Button, EmptyState } from '@betty/moonlight';
import animations from '../assets/animations';
import { useNavigation } from '@betty/navigation';

export function PromosListEmpty() {
  return (
    <EmptyState
      titleNS="promos"
      titleKey="emptyListTitle"
      descriptionNS="promos"
      descriptionKey="emptyListDescription"
      animationSource={animations.promo}
      animationProps={{ sizeX: 150, sizeY: 150 }}
    />
  );
}

export function PromoDetailsEmpty() {
  const navigation = useNavigation();

  return (
    <EmptyState
      titleNS="promos"
      titleKey="emptyDetailsTitle"
      descriptionNS="promos"
      descriptionKey="emptyDetailsDescription"
      animationSource={animations.promo}
      animationProps={{ sizeX: 150, sizeY: 150 }}
    >
      <Button
        variant="primary"
        onPress={navigation.goBack}
        locNS="common"
        locKey="goBack"
        size="large"
      />
    </EmptyState>
  );
}
